import { PayLoadValue, ValidationStatuses } from './form.model';

export enum CashierFieldConfigurationKeys {
  Field = 'field',
  Direction = 'direction',
  Platform = 'platform',
  Theme = 'theme',
  Density = 'density',
}

export enum IframeTypes {
  Leader = 'leader',
  Field = 'field',
}

export interface FieldPayload {
  errors: string[];
  validationStatus: ValidationStatuses;
  isFocused: boolean;
  value: PayLoadValue;
  isUiOnly?: boolean;
}

export interface SecuredFieldPayload extends FieldPayload {
  isFilled: boolean;
}

export interface SecuredFormPayload {
  [key: string]: FieldPayload;
}

export enum CashierMessages {
  LoadTokenizerV1 = 'loadTokenizerV1',
  CashierData = 'cashierData',
  InitializeData = 'initializeData',
  PostProcessSdkProcessorPayment = 'postProcessSdkProcessorPayment',
  GetEncryptedPayload = 'getEncryptedPayload',
}

export enum LeaderIframeMessages {
  BroadcastFields = 'broadcastFields',
  PreprocessorLoaded = 'preprocessorLoaded',
  SdkProcessorPaymentProcessed = 'sdkProcessorPaymentProcessed',
  TransferDataToParent = 'transferDataToParent',
  PayloadEncrypted = 'payloadEncrypted',
  TokenizerV1 = 'tokenizerV1',
  DisableFields = 'disableFields',
  FieldPayloadUpdated = 'fieldPayloadUpdated',
}

export const BROADCAST_CHANNEL = 'leader-field-channel';

export type DensityType = 'comfortable' | 'compact';
